// import Swiper from "swiper/dist/js/swiper.js";
import Swiper from 'swiper/bundle';
import anime from "animejs";

export default class Testimonial {
  constructor() {
    this.testimonials = document.querySelectorAll(".jsTestimonials");

    // helpers
    this._duration = 7500;
    this.circleAnimation = {};

    if (this.testimonials) this.init();
  }

  setCarousel(i) {
    this.type = i.getAttribute('data-type')
    this.testimonialNext = i.parentElement.querySelector(".jsTestimonialsNext");
    this.testimonialPrev = i.parentElement.querySelector(".jsTestimonialsPrev");
    this.testimonialPagination = i.parentElement.querySelector(".jsTestimonialsPagination");
    this.testimonialPath = i.parentElement.querySelector(".jsTestimonialCircle path");

    this.redraw = () => {};

    if (this.testimonialPath) {
      this.circleAnimation = anime({
        targets: this.testimonialPath,
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: "easeInOutSine",
        duration: this._duration,
        direction: "alternate",
        loop: true
      });

      this.redraw = () => {
        this.circleAnimation.restart();
      };
    }

    let autoplay = false

    if (this.type === 'automatic') {
      autoplay = {
        delay: this._duration,
        disableOnInteraction: false
      }
    }

    this.carousel = new Swiper(i, {
      loop: true,
      pagination: {
        el: this.testimonialPagination,
        clickable: true,
        renderBullet: (index, className) =>
          '<span class="carousel-bullet__item ' + className + '"></span>'
      },
      navigation: {
        nextEl: this.testimonialNext,
        prevEl: this.testimonialPrev
      },
      autoplay,
      on: {
        slideChange: this.redraw
      }
    });
  }

  init() {
    for (let i = 0; i < this.testimonials.length; i++) {
      const el = this.testimonials[i];
      this.setCarousel(el);
    }
  }
}
